

































































import { Component, Vue, Inject, Watch } from 'vue-property-decorator'

import { BoatClass, Regatta } from '@/assets/scripts/sapsa-api'

@Component
export default class RegattaListContent extends Vue {
    @Inject()
    private regattas!: Regatta[]

    @Inject()
    private boatClasses!: BoatClass[]

    @Inject()
    private linkMode!: 'tab'|'popup'|'hud'

    private iconUrlsByBoatClassName: { [boatClassName:string]: string } = {}
    private cleanClassNamesByRegattaName: { [regattaName:string]: string } = {}
    private raceState: { [regattaName: string]: { [raceName: string]: { running?: boolean, finished?: boolean } } } = { }

    @Watch('regattas', { immediate: true, deep: true })
    private calcDerived (): void {
        const now = new Date()
        const fiveMinutesAgo = new Date(now.setMinutes(-5))

        const iconUrlsByBoatClassName: { [boatClassName:string]: string } = {}
        const cleanClassNamesByRegattaName: { [regattaName:string]: string } = {}
        const raceState: { [regattaName: string]: { [raceName: string]: { running?: boolean, finished?: boolean } } } = { }

        this.regattas.forEach((regatta) => {
            // Boat class
            const boatClass = this.boatClasses.find((boatClass) => boatClass.name === regatta.boatClass)
            if (boatClass != null) {
                if (boatClass.iconUrl != null) {
                    iconUrlsByBoatClassName[boatClass.name] = boatClass?.iconUrl
                }
                cleanClassNamesByRegattaName[regatta.name] = boatClass.name.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '').replace(/\s+/g, '-').toLowerCase()
            }

            // Running / finished
            if (raceState[regatta.name] == null) {
                raceState[regatta.name] = {}
            }
            for (let index = 0; index < regatta.races.length; index++) {
                const race = regatta.races[index]

                if (raceState[regatta.name][race.name] == null) {
                    raceState[regatta.name][race.name] = {}
                }

                raceState[regatta.name][race.name].running = race.startTime != null ? race.startTime < fiveMinutesAgo : false

                const end = race.endOfRace != null ? race.endOfRace : race.endOfTracking
                raceState[regatta.name][race.name].finished = end != null ? end < now : false

                // If the race has finished, then it is no longer running
                if (raceState[regatta.name][race.name].finished === true) {
                    raceState[regatta.name][race.name].running = false
                }

                // If the race has finished or is still running, then the one before is probably finished as well
                if (index !== 0 && (raceState[regatta.name][race.name].finished === true || raceState[regatta.name][race.name].running === true)) {
                    const previousRace = regatta.races[index - 1]
                    raceState[regatta.name][previousRace.name].running = false
                    raceState[regatta.name][previousRace.name].finished = true
                }
            }
        })

        this.iconUrlsByBoatClassName = iconUrlsByBoatClassName
        this.cleanClassNamesByRegattaName = cleanClassNamesByRegattaName
        this.raceState = raceState
    }

    private openLink (event: Event): boolean {
        const element = event.target as HTMLAnchorElement
        const href = element.getAttribute('href')
        if (href != null && this.linkMode === 'popup') {
            event.preventDefault()
            window.open(href, Math.random().toString(36).substring(7), // random window ref to make sure that two windows can stay open at the same time
            'width=1280,height=720,toolbar=1,resizable=0')
            return false
        }
        return true
    }
}
